/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {ReactComponent as Search} from "../assets/img/icons/search-check.svg";
import Filter from "../elements/Filter";
import {Link, useNavigate, useParams} from "react-router-dom";
import FilterDouble from "./FilterDouble";
import {useTranslation} from "react-i18next";


const FiltersParts = (props) => {

    let params = useParams();
    const queryParameters = new URLSearchParams(window.location.search);
    const _bodytype = queryParameters.get("bodytype");

    const { t, i18n } = useTranslation();

    return (
        <>
            <div className='filters-title'>
                <div className='filters-title__icon'>
                    <Search/>
                </div>
                <div className='filters-title__content'>
                    <div className='filters-title__label'>{ t('parts.findUsed' ) }</div>
                    {/*<div className='filters-title__text'>Search 26,673 Vehicles</div>*/}
                </div>
            </div>

            {!props.dismantlerPartsCategories &&
                <div className='filters-reset-all'>
                    <Link to={`/${i18n.language}/parts/categories`} className='reset-all'>
                        Reset
                    </Link>
                </div>
            }


            <div className='filters'>

                {props.categories.map((item, index) => {
                    return (
                         //<Filter flter={item} key={index} link={`/parts/listing/${params.make}/${params.model}/slug/${params.year}`}/>
                         <FilterDouble filter={item} key={index} link={`/${i18n.language}/parts/listing/${params.make}/${params.model}/slug/${params.year}?bodytype=${_bodytype}&spec=value`}/>
                    );
                })}

                {props.categoriesAll.map((item, index) => {
                    return (
                        // <Filter flter={item} key={index} link={`/parts/categories/slug`}/>
                        <FilterDouble filter={item} key={index} link={`/${i18n.language}/parts/categories/slug/?spec=value`}/>
                    );
                })}

                {props.dismantlerPartsCategories.map((item, index) => {
                    return (
                        <FilterDouble filter={item} key={index} link={`/${i18n.language}/mini-site/parts/${params.merchantid}/${params.companyname}/slug/?spec=value`}/>
                    );
                })}

            </div>
        </>
    );
};

/* to ferno sto PartsListing kai sto PartsListingAll kai sta props exo diaforetiko onoma, opote to ena einai adeio kai to allo fernei data. */

FiltersParts.defaultProps = {
    categories: [],
    categoriesAll: [],
    dismantlerPartsCategories: [],
};

export default FiltersParts;
